import { Grid, Tooltip} from "@mui/material";

export function getRawdemandStruct(){
    return {
        id:{
            name:'id',
            label:'ID',
            value:'',
            error:false,
            errorMessage:'',
            required:false
        },
        
        businessid:{
            name:'businessid',
            label:'Business Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        title:{
            name:'title',
            label:'title',
            value:'',
            error:false,
            errorMessage:'You must enter title',
            required:true,
            fieldtype:'string'
        },
        qty:{
            name:'qty',
            label:'Qty',
            value:'',
            error:false,
            errorMessage:'You must enter Qty',
            required:true,
            fieldtype:'number'
        },
        unit:{
            name:'unit',
            label:'Unit',
            value:'',
            error:false,
            errorMessage:'You must enter Unit',
            required:true,
            fieldtype:'string'
        },
        status:{
            name:'status',
            label:'Status',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        rmid:{
            name:'rmid',
            label:'RM ID',
            value:'',
            error:false,
            errorMessage:'You must enter RM ID',
            required:true,
            fieldtype:'ID'
        },
        vendorid:{
            name:'vendorid',
            label:'Vendor Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'bodynamiclist'
        },
        vendorname:{
            name:'vendorname',
            label:'Vendor Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        price:{
            name:'price',
            label:'Price',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'double'
        },
      }
}

export function getColumns(payload){
  let actionList = [
        
        { field: 'title', headerName: 'title', width:150 },
        { field: 'qty', headerName: 'Qty', width:150 },
        { field: 'unit', headerName: 'Unit', width:150 },
        { field: 'status', headerName: 'Status', width:150 },
        { field: 'rmid', headerName: 'RM ID', width:150 },
        { field: 'vendorname', headerName: 'Vendor Name', width:150 },
        { field: 'price', headerName: 'Price', width:150 },
  ];
  if (payload!==undefined){
    payload.actionList && payload.actionList.map((actionObj)=>{
    actionList.push(
      {
        field: actionObj.title,
        headerName: actionObj.title,
        sortable: false,
        width:60,
        disableClickEventBubbling: false,
        renderCell: (params) => {
          return (
              <Grid item onClick={()=>{actionObj.callBackMethod(params.row.id)}}>
                <Tooltip title={actionObj.title} sx={{cursor: "pointer"}}>
                  {actionObj.icon}
                </Tooltip>
              </Grid>
          );
        }
      })
    })
  }
  return actionList;
}

export function setData(data, formValues, setFormValues){
   
    setFormValues({
      ['id']:{
        ...formValues['id'],
        value:data.id,
      },
       ['businessid']:{
          ...formValues['businessid'],
          value:data.businessid,
        },['title']:{
          ...formValues['title'],
          value:data.title,
        },['qty']:{
          ...formValues['qty'],
          value:data.qty,
        },['unit']:{
          ...formValues['unit'],
          value:data.unit,
        },['status']:{
          ...formValues['status'],
          value:data.status,
        },['rmid']:{
          ...formValues['rmid'],
          value:data.rmid,
        },['vendorid']:{
          ...formValues['vendorid'],
          value:data.vendorid,
        },['vendorname']:{
          ...formValues['vendorname'],
          value:data.vendorname,
        },['price']:{
          ...formValues['price'],
          value:data.price,
        },
      })
}